import { Box } from '@mui/material';

export const Spring = () => <Box flex="1 1 auto" />;
